import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { Redirect, withRouter, Link } from "react-router-dom";
class BreadcrumbsPage extends React.Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mt20">
            <h1 className="text-center">
              <FontAwesomeIcon icon={faCogs} size="lg" />
              <span>MASTERS</span>
            </h1>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BreadcrumbsPage);
